import { createClient } from '@supabase/supabase-js';

// Project Supabase URL and Publishable Anon Key
export const supabaseUrl =
  (typeof import.meta !== 'undefined' && import.meta.env?.VITE_SUPABASE_URL) ||
  (typeof process !== 'undefined' && process.env?.VITE_SUPABASE_URL) ||
  'https://vnfihflfxbxhssfkuvga.supabase.co';

export const supabaseAnonKey =
  (typeof import.meta !== 'undefined' && import.meta.env?.VITE_SUPABASE_ANON_KEY) ||
  (typeof process !== 'undefined' && process.env?.VITE_SUPABASE_ANON_KEY) ||
  'sb_publishable_C3khCuAajdhX3rC-if0xLQ_TFaoKGAm';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

/**
 * Ensures an active user session exists (auto-initializes anonymous guest if needed)
 */
export async function getOrCreateSession() {
  try {
    const { data: { session } } = await supabase.auth.getSession();
    if (session) return session;

    const { data, error } = await supabase.auth.signInAnonymously();
    if (error) {
      console.error('Failed to initialize anonymous guest session:', error);
      return null;
    }
    return data.session;
  } catch (err) {
    console.error('Supabase session error:', err);
    return null;
  }
}
